"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = require("styled-components");
const styles_1 = require("@mui/material/styles");
const theme_1 = __importDefault(require("./theme"));
const materialTheme_1 = require("./materialTheme");
const Provider = ({ children, customTheme, }) => {
    return (react_1.default.createElement(styled_components_1.ThemeProvider, { theme: customTheme || theme_1.default },
        react_1.default.createElement(styles_1.StyledEngineProvider, { injectFirst: true },
            react_1.default.createElement(styles_1.ThemeProvider, { theme: customTheme
                    ? (0, materialTheme_1.createMaterialTheme)(customTheme.palette)
                    : materialTheme_1.materialTheme }, children))));
};
exports.default = Provider;
//# sourceMappingURL=Provider.js.map